//#region Import
import { DicomBox, convertDwvPosition } from "./DicomManager";
import {
  axViewer,
  update3dNervePoints,
  removeNervePoint,
} from "./AuxiliaryManager";
import { getAllFiguresForModel } from "./slice";
import {
  drawAnnotations,
  destroyAnnotationShapes,
  updateFigureMinMax,
} from "./annotation";
import { getNerveStlFromPoints } from "@/api/toothApi";
import { saveBlob, saveLocalJson } from "@/components/reports/fileMethods";
import { STLExporter } from "three/addons/exporters/STLExporter.js";
import { STLLoader } from "three/addons/loaders/STLLoader.js";
// import {} from "./annotation";
import { DynamicTubeGeometry } from "../geometry/DynamicTubeGeometry";
import { drawBox, drawPoint } from "../draw/draw";
let dwv = require("dwv");
//#endregion

//#region Fields
const annotationShapeName = "annotationShape";
let anchorMenu = null; // document.getElementById("annotation-nerve-anchor-menu");
let anchorRemoveBtn = null; // document.getElementById("annotation-nerve-remove-anchor-btn");
//#endregion

async function loadNervePoints(annotation, app) {
  attachAnchorMenu(app);

  if (annotation.isNerve && !annotation.pointsLoaded) {
    // ann

    let sliceIndexes = Object.keys(annotation.allFigures)
      .filter(
        (k) => annotation.allFigures[k] && annotation.allFigures[k].length > 0,
      )
      .map((k) => +k - 1);
    console.log("loadNervePoints", sliceIndexes);

    annotation.middleNervePoints = [];

    const layerGroup = app.getLayerGroupByDivId(app.divId);
    const viewLayer = layerGroup.getActiveViewLayer();
    const viewController = viewLayer.getViewController();

    const geometry = app.geometry;
    const origin = geometry.getOrigin();
    const dwvOrigin = new THREE.Vector3(
      origin.getX(),
      origin.getY(),
      origin.getZ(),
    );

    let pointsUrl = annotation.model.isLeft
      ? `${vueApp.stlBaseUrl}/left_segment_points.txt`
      : `${vueApp.stlBaseUrl}/right_segment_points.txt`;
    try {
      let response = await fetch(pointsUrl, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
      });
      if (response.ok) {
        const text = await response.text();
        const lines = text.split(/\r?\n/).filter((line) => line.trim() !== "");
        let allPos = [];
        let count = lines.length;
        for (let i = count - 1; i >= 0; i--) {
          const line = lines[i];
          const arr = line.split(",");
          let x = +arr[0];
          let y = +arr[1];
          let z = +arr[2];
          const values = [-x, -y, z];
          let pos = new dwv.Point(values);
          pos.x = values[0];
          pos.y = values[1];
          pos.z = values[2];
          let planePos = viewController.convertWorldPosToFullPlanePos(pos);
          let roundZ = Math.round(planePos.z);
          planePos.z = roundZ;
          // console.log("planePos.z", roundZ, pos, planePos);
          pos.planePos = planePos;

          allPos.push(pos);
        }

        allPos = allPos.filter((p) => sliceIndexes.includes(p.planePos.z));

        const middlePoints = [];
        for (let i = 0; i < allPos.length; i++) {
          let pos = allPos[i];
          let planePos = pos.planePos;
          let figPlanePos = getPlanePosFromFigures(planePos, annotation);
          if (figPlanePos != planePos) {
            pos = viewController.convertFullPlanePosToWorldPos(figPlanePos);
            pos.planePos = figPlanePos;
          }

          const vPosition = convertDwvPosition(pos, dwvOrigin);
          if (i == 0) {
            annotation.startNervePoint = vPosition;
          } else if (i == allPos.length - 1) {
            annotation.endNervePoint = vPosition;
          } else {
            middlePoints.push(vPosition);
          }
        }

        let sp = annotation.startNervePoint;
        while (middlePoints.length) {
          let mp = middlePoints[0];
          let distance = getDistance3D(sp, mp);
          if (distance >= 3) {
            annotation.middleNervePoints.push(mp);
            sp = mp;
          }
          middlePoints.splice(0, 1);
        }

        annotation.allNervePoints = [annotation.startNervePoint]
          .concat(annotation.middleNervePoints)
          .concat(annotation.endNervePoint)
          .filter((p) => !!p);

        annotation.pointsLoaded = true;
      }
    } catch (e) {
      console.log(`loadNervePoints error: ${e}`);
    }
  }
}

function getPlanePosFromFigures(basePlanePos, annotation) {
  let retval = basePlanePos;
  if (basePlanePos && annotation) {
    let figures = annotation.allFigures[basePlanePos.z + 1];
    let nearFigure = figures && figures.length ? figures[0] : null;
    if (nearFigure) {
      for (const figure of figures) {
        updateFigureMinMax(figure);
      }

      if (figures.length > 1) {
        let minDistance = Infinity;
        for (const figure of figures) {
          let distance = getDistance2D(basePlanePos, figure.center);
          if (distance < minDistance) {
            minDistance = distance;
            nearFigure = figure;
          }
        }
      }

      retval = {
        x: nearFigure.center.x,
        y: nearFigure.center.y,
        z: basePlanePos.z,
      };
    }
  }

  return retval;
}

function getDistance2D(p1, p2) {
  var dx = p1.x - p2.x;
  var dy = p1.y - p2.y;
  return Math.sqrt(dx * dx + dy * dy);
}

function getDistance3D(point1, point2) {
  var dx = point1.x - point2.x;
  var dy = point1.y - point2.y;
  var dz = point1.z - point2.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

function attachAnchorMenu(app) {
  if (!anchorMenu) {
    anchorMenu = app.anchorMenu = document.getElementById(
      "annotation-nerve-anchor-menu",
    );
    anchorRemoveBtn = document.getElementById(
      "annotation-nerve-remove-anchor-btn",
    );

    anchorRemoveBtn.addEventListener("click", () => {
      anchorMenu.style.display = "none";
      let annotation = anchorRemoveBtn.annotation;
      let point = anchorRemoveBtn.point;
      console.log("anchorRemoveBtn click", point);
      removeNervePoint(point.mesh);
    });
  }
}

function updateNervePoints(app, annotation) {
  annotation.allNervePoints = [annotation.startNervePoint]
    .concat(annotation.middleNervePoints)
    .concat(annotation.endNervePoint)
    .filter((p) => !!p);

  for (const point of annotation.allNervePoints) {
    point.updateCallback = updateNervePointPosition;
  }

  destroyAnnotationShapes(app);
  drawAnnotations(app, DicomBox);
  update3dNervePoints(annotation);
}

function updateNervePointPosition(app, annotation, point, newX, newY) {
  console.log("updateNervePointPosition", point, newX, newY);
  const layerGroup = app.getLayerGroupByDivId(app.divId);
  const viewLayer = layerGroup.getActiveViewLayer();
  const viewController = viewLayer.getViewController();
  const geometry = app.geometry;
  const origin = geometry.getOrigin();
  const dwvOrigin = new THREE.Vector3(
    origin.getX(),
    origin.getY(),
    origin.getZ(),
  );

  let planePos = point.planePos;
  planePos.x = newX;
  planePos.y = newY;
  let dwvPos = viewController.convertFullPlanePosToWorldPos(planePos);
  dwvPos.planePos = planePos;

  const newPosition = convertDwvPosition(dwvPos, dwvOrigin);

  point.setX(newPosition.x);
  point.setY(newPosition.y);
  point.setZ(newPosition.z);
  point.dicomPos = dwvPos;
  point.planePos = dwvPos.planePos;

  updateNervePoints(app, annotation);
}

/// Server request
async function updateNerveFromPoints(annotation) {
  console.log("updateNerveFromPoints");

  // annotation.allNervePoints = [annotation.startNervePoint]
  //   .concat(annotation.middleNervePoints)
  //   .concat(annotation.endNervePoint);

  let sortedPoints = getSortedNervePoints(annotation);
  if (!sortedPoints || sortedPoints.length < 2) return null;
  annotation.sortedPoints = sortedPoints;

  let nerveGeometry = null;
  let box = null;

  const string_arr = [];
  for (const point of sortedPoints) {
    let pos = point.dicomPos;
    const line = `${-pos.x}, ${-pos.y}, ${pos.z}`;
    string_arr.push(line);
  }

  try {
    const response = await getNerveStlFromPoints(string_arr);
    if (response && response.status == 200) {
      let arrayBuffer = response.data;
      nerveGeometry = loader.parse(arrayBuffer);
      let loader = new STLLoader();
      nerveGeometry.computeBoundingBox();
      console.log("updateNerveFromPoints geometry", nerveGeometry);

      box = nerveGeometry.boundingBox;
      box = rotateBox(box, -defaultXOffset, -defaultYOffset, -defaultZOffset);

      let matrix2 = new THREE.Matrix4();
      matrix2.makeRotationAxis(new THREE.Vector3(0, 1, 0), rotateY);
      nerveGeometry.applyMatrix4(matrix2);

      let matrix1 = new THREE.Matrix4();
      matrix1.makeRotationAxis(new THREE.Vector3(1, 0, 0), rotateX);
      nerveGeometry.applyMatrix4(matrix1);
    }
  } catch (error) {}

  if (!nerveGeometry) {
    nerveGeometry = createTubeGeometry(sortedPoints);
    nerveGeometry.computeBoundingBox();
    box = offsetBox(nerveGeometry.boundingBox);
  }

  if (nerveGeometry) {
    nerveGeometry.center();

    nerveGeometry = new THREE.Geometry().fromBufferGeometry(nerveGeometry);
    // cgeometry.mergeVertices();
    nerveGeometry.computeVertexNormals();
    nerveGeometry = new THREE.BufferGeometry().fromGeometry(nerveGeometry);
    nerveGeometry.computeBoundingBox();

    nerveGeometry.baseBox = box;
  }

  return nerveGeometry;

  // let vmesh = new THREE.Mesh(geometry);
  // const stlExporter = new STLExporter();
  // const data = stlExporter.parse(vmesh, { binary: true });
  // const blob = new Blob([data], { type: "application/octet-stream" });
  // saveBlob(blob, `updated-${annotation.filename}`);
  // }
}

function getSortedNervePoints(annotation) {
  if (!annotation) return null;

  let middlePoints = annotation.middleNervePoints
    ? [
        ...annotation.middleNervePoints.sort(
          (p1, p2) => p1.planePos.z - p2.planePos.z,
        ),
      ]
    : [];
  const pointsMap = middlePoints.reduce((acc, p) => {
    let z = p.planePos.z;
    if (!acc[z]) {
      acc[z] = [];
    }
    acc[z].push(p);
    return acc;
  }, {});

  let sortedPoints = [annotation.startNervePoint];

  while (middlePoints.length > 0) {
    let p = middlePoints[0];
    let z = p.planePos.z;

    let index = 0;
    let levelPoints = pointsMap[z];
    if (levelPoints.length > 1) {
      levelPoints = levelPoints.sort((p1, p2) => p1.planePos.y - p2.planePos.y);
      p = levelPoints[0];
      index = middlePoints.indexOf(p);
    }

    sortedPoints.push(p);
    middlePoints.splice(index, 1);
  }

  sortedPoints.push(annotation.endNervePoint);
  sortedPoints = sortedPoints.filter((p) => !!p);
  if (sortedPoints.length < 2) return null;

  return sortedPoints;
}

function createTubeGeometry(points) {
  if (!points || points.length < 2) {
    return;
  }

  // let lcurve = new THREE.LineCurve3(sortedPoints[0], sortedPoints[sortedPoints.length - 1]);
  // let tubeGeometry = new THREE.TubeGeometry(
  //   lcurve,
  //   10, // tubularSegments
  //   0.6, // radius
  //   8, // radialSegments
  //   true, // closed
  // );
  // console.log("createTubeGeometry", points);
  const radius = 0.6;
  const tubeGeometry = DynamicTubeGeometry(
    radius,
    64,
    points.length * 2,
    false,
    false,
  );
  tubeGeometry.update(radius, points);

  return tubeGeometry;
}

export {
  loadNervePoints,
  updateNerveFromPoints,
  updateNervePoints,
  getSortedNervePoints,
};
